﻿$.fn.dxCtrlContentSmsMobile = function custom_dxCtrlContentSmsMobile(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentsmsmobile dx-ctrl");
        this.createInstance(new cdxCtrlContentSmsMobile(this, option));
    }
    return this;
}

window.NOMBRE_DESTINATAIRE_A_SMS_MAX = 20
window.idxEditorSms = 0
window.cdxCtrlContentSmsMobile = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $TxtArea = null
    var $TxtAreaEmoji = null
    var $DivEntete = null
    var $DivDetail = null
    var $DivMobile = null
    function mConstruit() {
        container.empty()

        container.css({
            "display": "flex",
            "justify-content": "center",
            "align-items": "center"
        })

        idxEditorSms += 1

        //$DivMobile = $("<div style='position:absolute;width:100%;height:calc(100% - " + ((!dxTabs) ? "0" : (dxTabs.element().innerHeight() + 20)) + "px);display:none;justify-content:center;align-items:center;'/>").appendTo($DivContent)

        var $DivMobileInterne = $("<div style='width:100%;height:100%;max-width:360px;max-height:1200px;position:relative;'/>").appendTo(container)
        var $DivTop = $("<div style='position:absolute;top:0;right:0;height:70px;width:100%;background-color:black;border-radius:30px 30px 0 0;display:flex;justify-content:center;align-items:center;'/>").appendTo($DivMobileInterne)
        $("<div style='width:25px;height:8px;background-color:white;border-radius:5px;'/>").appendTo($DivTop)
        var $DivLeft = $("<div style='position:absolute;top:70px;right:0;height:calc(100% - 230px);width:20px;background-color:black;'/>").appendTo($DivMobileInterne)
        var $DivRight = $("<div style='position:absolute;top:70px;left:0;height:calc(100% - 230px);width:20px;background-color:black;'/>").appendTo($DivMobileInterne)
        var $DivBottom = $("<div style='position:absolute;bottom:125px;right:0;height:90px;width:100%;background-color:black;border-radius:0 0 30px 30px;display:flex;justify-content:center;align-items:center;margin-bottom:5px;'/>").appendTo($DivMobileInterne)
        $DivDetail = $("<div style='font-family:barlow condensed;position:absolute;bottom:0;text-align:center;opacity:1;font-size:120%;width:100%;'></div>").appendTo($DivMobileInterne)
        var $DivRond = $("<div style='width:40px;height:40px;background-color:white;border-radius:50%;'/>").appendTo($DivBottom)

        var $DivContainer = $("<div style='position:absolute;top:70px;left:20px;width:calc(100% - 40px);height:calc(100% - 220px);'/>").appendTo($DivMobileInterne)
        var $DivContainerInner = $("<div style='width:100%;height:100%;position:relative;'/>").appendTo($DivContainer)
        $DivEntete = $("<div style='width:100%;'/>").appendTo($DivContainerInner)

        var $DivGrid = $("<div style='position:absolute;top:" + $DivEntete.innerHeight() + "px;height:calc(100% - " + ($DivEntete.innerHeight() + 200 + 15) + "px);z-index:0;' class='containergrid'/>").appendTo($DivContainerInner)


        var $DivContainerEditor = $("<div style='position:absolute;bottom:75px;max-height:calc(100% - " + ($DivEntete.innerHeight() + 15) + "px);height:140px;width:100%;border-top:" + theme.border + ";'/>").appendTo($DivContainerInner)

        $DivEditor = $("<div id='iddd" + idxEditorSms + "' style='height:100%;'/>").appendTo($DivContainerEditor)
        txtSaved = new cSendSms(option.bddCtrl, ((option.data.body_txt == null) ? "" : option.data.body_txt), option.data.ajout_stop == "1").mGetTextWithoutSeparateurLink()
        $TxtArea = $("<textarea id='idemoji" + idxEditorSms + "' placeholder='Saisissez votre message...' style='height:100%;width:100%;resize:none;'>" + txtSaved + "</textarea>").appendTo($DivEditor)
        if (!(option.data.date_envoi == null || option.data.id_type_classement == 11)) {
            $TxtArea.attr("disabled", "true")
        } else {
            $TxtArea.emojioneArea({
                pickerPosition: "top",
                tonesStyle: "bullet",
                searchPlaceholder: "Rechercher...",
                events: {
                    onLoad: function () {
                        window.setTimeout(function () {
                            $TxtAreaEmoji = $TxtArea[0].emojioneArea
                            Me.isDirty(false)
                            mChange()
                        }, 0)
                    }
                }
            });
        }
    }

    this.mUpdate = function () {
        mChange(true)
    }
    var nbCaractereOld = null
    var nbCreditOld = null
    var txtSaved = null
    function mChange(forcer) {
        if (container.closest("body").length = 0) return
        var txt = $TxtAreaEmoji.getText()
        if (txt == null) txt = ""
        var sendSms = new cSendSms(option.bddCtrl, txt, option.data.ajout_stop == "1")
        option.data.body_txt = sendSms.mGetTextSmsWithSeparateurLink()

        var nbCaractereNew = sendSms.mGetNbCaractereMessage()

        var nbCreditNew = sendSms.mGetNbCredit1MessageFrance()
        if (forcer || nbCaractereNew != nbCaractereOld || nbCreditNew != nbCreditOld) {
            if ($TxtAreaEmoji != null) {
                if (option.data.body_txt.length == 0) {
                    $DivDetail.empty()
                    nbCaractereOld = 0
                    nbCreditOld = 0
                } else {
                    nbCaractereOld = nbCaractereNew
                    nbCreditOld = nbCreditNew
                    $DivDetail.empty()
                    var $DivPlus = $("<div style='position:relative;width:100%;text-align:center;'/>").appendTo($DivDetail)
                    if (nbCaractereOld > sendSms.mGetMaxCar()) $("<i class='fas fa-triangle-exclamation blinkscalealways' style='display:inline-block;z-index:5;font-size:400%;color:red;opacity:0.5;position:absolute;text-align:center;left:calc(50% - 30px);'></i>").appendTo($DivPlus)
                    var $DivTab = $("<div style='position:relative;height:32px;margin-bottom:5px;'/>").appendTo($DivPlus)
                    var $Table = $("<table style='width:100%;position:absolute;z-index:2;'/>").appendTo($DivTab)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var css = "border:" + theme.border + ";width:" + (100 / 6) + "%;padding:4px 0;"
                    var $Td = $("<td style='" + css + ((nbCreditOld >= 1) ? "background-color:LightBlue;" : "") + "'>1 sms</td>").appendTo($Tr)
                    var $Td = $("<td style='" + css + ((nbCreditOld >= 2) ? "background-color:LightBlue;" : "") + "'>2 sms</td>").appendTo($Tr)
                    var $Td = $("<td style='" + css + ((nbCreditOld >= 3) ? "background-color:LightBlue;" : "") + "'>3 sms</td>").appendTo($Tr)
                    var $Td = $("<td style='" + css + ((nbCreditOld >= 4) ? "background-color:LightBlue;" : "") + "'>4 sms</td>").appendTo($Tr)
                    var $Td = $("<td style='" + css + ((nbCreditOld >= 5) ? "background-color:LightBlue;" : "") + "'>5 sms</td>").appendTo($Tr)
                    var $Td = $("<td style='" + css + ((nbCreditOld >= 6) ? "background-color:LightBlue;" : "") + "'>6 sms</td>").appendTo($Tr)
                    var widthPercent = (nbCaractereOld * (100 / sendSms.mGetMaxCar()))
                    var $DivJauge = $("<div style='position:absolute;background-color:navy;opacity:0.5;height:100%;width:calc(" + ((widthPercent > 100) ? 100 : widthPercent) + "% - 0px);z-index:3;'/>").appendTo($DivTab)
                    var $DivNbCarSms = $("<div>" + sendSms.mGetNbCarBySms() + " caractères par SMS</div>").appendTo($DivPlus)
                    if (sendSms.isUniCode()) {
                        $("<span style='opacity:0.3;'> &bull; (" + sendSms.nbCarBySmsString + " sans émoji😥)</span>").appendTo($DivNbCarSms)
                        $DivNbCarSms.attr("title", "Vous utilisez des emojis, des langues non latines (Arabe, Chinois, Russe, etc) dans votre message.<br/>Attention! Le nombre de caractères possible par SMS passe de " + option.bddCtrl.getObjet("com_sms_envoi").objetMetier.nbCarBySmsString + " à " + option.bddCtrl.getObjet("com_sms_envoi").objetMetier.nbCarBySmsUnicode + "!<br/>Afin d‘éviter les soucis d'encodage avec certains téléphones, il faut mettre des espaces devant les emojis")
                    }
                    var $DivTxt = null
                    //if (dxTagBoxDest.mGetLstDestinataire().length == 1 && dxTagBoxDest.mGetLstDestinataire()[0].tel_code_pays != null) {
                    //    var indic = parametre.lstIndicatifTel.filter(function (o) { return o.code == dxTagBoxDest.mGetLstDestinataire()[0].tel_code_pays })[0]
                    //    var nbCredit = sendSms.mGetNbCredit1Message(dxTagBoxDest.mGetLstDestinataire()[0].tel_code_pays, true)
                    //    //var nbCredit = option.bddCtrl.getObjet(dxTagBoxDest.mGetLstDestinataire()[0]).objetMetier.mGetCalculNbCreditToUseFromCodePays(nbCreditOld)
                    //    $DivTxt = $("<div>" + nbCaractereOld + " car" + ((nbCaractereOld > 1) ? "s" : "") + " soit <b" + ((nbCredit >= 2) ? " style = 'color:red'" : "") + "> " + nbCredit + "</b> sms/destinataire <span style='font-size:70%;opacity:0.3;'>(" + indic.name + ")</span> </div>").appendTo($DivPlus)
                    //} else {
                    //    //plusieurs dest
                    //    //on met pas de détails
                    $DivTxt = $("<div>" + nbCaractereOld + " car" + ((nbCaractereOld > 1) ? "s" : "") + " soit <b" + ((nbCreditOld >= 2) ? " style = 'color:red'" : "") + "> " + nbCreditOld + "</b> sms/destinataire <span style='font-size:70%;opacity:0.3;'>(France métropolitaine)</span> </div>").appendTo($DivPlus)
                    //}
                    var $A = $("<a href='javascript:void(0)' title='Tarif des SMS par pays' style='font-size:80%'>Détails</a>").appendTo($DivTxt)
                    $A.on("click", function () {
                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                            width: 250,
                            target: $A,
                            contentTemplate: function (contentElement) {
                                contentElement.css("padding", "15px")
                                var sendSms = new cSendSms(option.bddCtrl)
                                sendSms.mGetDivTarifSmsParPays(contentElement)
                            }
                        }).dxCtrlTooltip("instance")
                        tt.show()
                    })
                    //var $DivTxt = $("<div style='opacity:0.3'>" + dxTagBoxDest.mGetLstDestinataire().length + " destinataire" + ((dxTagBoxDest.mGetLstDestinataire() > 1) ? "s" : "") + " - " + mGetTotalCredits() + " crédits</div>").appendTo($DivPlus)
                    //var $DivTxt = $("<div style='opacity:0.3'>" + mGetDetailCreditHtml() + "</div>").appendTo($DivPlus)
                }
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged()
            } else { $DivDetail.empty() }
            option.bddCtrl.getObjet(option.data).mSaveChamp("body_txt", function () {
                window.setTimeout(function () { mChange() }, 1000)
            })
        } else {
            window.setTimeout(function () { mChange() }, 1000)
        }
    }

    this.isDirty = function (dirty) {
        if (typeof dirty != 'undefined') {
            if (dirty) { txtSaved = null }
            else { txtSaved = $TxtAreaEmoji.getText() }
        }
        return txtSaved != $TxtAreaEmoji.getText()
    }

    function mStartSaveAuto() {
        timeOutSaveAuto = window.setTimeout(function () { Me.mSaveAuto() }, 10000)
        var popupPage = null
        if (typeof page.mGetPopupPage != 'undefined') popupPage = page.mGetPopupPage(option.data)
        if (popupPage != null) {
            var onclose = popupPage.option("onClose")
            popupPage.option("onClose", function (e, funcFin) {
                Me.mStopSaveAuto(function () {
                    if (typeof onclose != 'undefined') onclose(e)
                    if (typeof funcFin != 'undefined') funcFin()
                })
            })
        }
    }
    var saveAuto = true
    this.mStopSaveAuto = function (funcFin) {
        saveAuto = false
        window.clearTimeout(timeOutSaveAuto)
        this.mSaveAuto(funcFin)
    }
    var timeOutSaveAuto = null
    this.mSaveAuto = function (funcFin, forcer) {
        if (typeof forcer == "undefined") forcer = false
        window.clearTimeout(timeOutSaveAuto)
        if (Me.isDirty() || forcer) {
            Me.mSave(function (parametre) {
                if (typeof funcFin != 'undefined') funcFin(parametre)
                if (saveAuto && container.closest("body").length > 0) timeOutSaveAuto = window.setTimeout(function () { Me.mSaveAuto() }, 10000)
            })
        } else {
            if (typeof funcFin != 'undefined') funcFin()
            if (saveAuto && container.closest("body").length > 0) timeOutSaveAuto = window.setTimeout(function () { Me.mSaveAuto() }, 10000)
        }
    }
    this.mSave = function (funcFin) {
        if ($TxtAreaEmoji == null) { window.setTimeout(function () { Me.mSave(funcFin) }, 100) }
        else {
            Me.isDirty(false)
            var txt = $TxtAreaEmoji.getText()
            var sendSms = new cSendSms(option.bddCtrl, txt, option.data.ajout_stop == "1")
            option.data.body_txt = sendSms.mGetTextSmsWithSeparateurLink()
            option.bddCtrl.getObjet(option.data).mSave(function (data) {
                funcFin(data)
            })
        }
    }

    this.focus = function () { }

    this.element = function () { return container }

    mConstruit();
}